<template>
  <footer class="foot_box">
    <div class="nav_foot_container">
      <div class="nav_foot_body">
        <ul v-for="(footNavBox, footNavIdx) in footNavList" :key="footNavIdx">
          {{
            footNavBox.label
          }}
          <li
            v-for="(footNavItem, footNavItemIdx) in footNavBox.list"
            :key="footNavItemIdx"
          >
            <a :href="footNavItem.href" v-show="footNavItem.href">{{
              footNavItem.label
            }}</a>
            <a
              @click="sendGa($event, 'apps.apple')"
              v-show="!footNavItem.href"
              >{{ footNavItem.label }}</a
            >
          </li>
        </ul>
      </div>
      <div class="nav_foot_download_container">
        <a href="/dl">
          <img
            v-if="t(true,false)"
            src="../assets/img/ic_home_totok.png"
            alt="HD video call and voice chat for free "
            class="downloadshop--pc"
          />
          <img
            v-else
            src="../assets/img/ic_home_totok_ar.png"
            alt="HD video call and voice chat for free "
            class="downloadshop--pc"
          />
        </a>
        <a
          @click="
            sendGa(
              $event,
              'https://appgallery.cloud.huawei.com/marketshare/app/C101085053?locale=en_US&amp;source=appshare&amp;subsource=C101085053'
            )
          "
        >
          <img
            v-if="t(true,false)"
            src="../assets/img/huaweilogo_homepage.png"
            alt="ToTok app download for Huawei devices "
            class="downloadshop--pc"
          />
          <img
            v-else
            src="../assets/img/huaweilogo_homepage_ar.png"
            alt="ToTok app download for Huawei devices "
            class="downloadshop--pc"
          />
        </a>
        <!-- <a
            @click="
              sendGa(
                $event,
                'https://static.totok.ai/mac/ToTok_for_Mac_v1_0_2_1.dmg',
                'mac'
              )
            "
          >
            <img
              v-if="t(true,false)"
              src="@/assets/img/ic_home_mac.png"
              alt="download ToTok apk on apkpure"
              class="downloadshop--pc"
            />
            <img
              v-else
              src="@/assets/img/ic_home_mac_ar.png"
              alt="download ToTok apk on apkpure"
              class="downloadshop--pc"
            />
          </a> -->
           <a
            @click="
              sendGa(
                $event,
                'https://galaxystore.samsung.com/detail/ai.totok.chat?badge=videocall&session_id=W_42cd90632a74824155ad5624d64ed728',
                'Samsung'
              )
            "
          >
            <img
              v-if="t(true,false)"
              src="@/assets/img/ic_home_samsung.png"
              alt="download ToTok free video call app for Samsung"
              class="downloadshop--pc"
            />
            <img
              v-else
              src="@/assets/img/ic_home_samsung.png"
              alt="download ToTok free video call app for Samsung"
              class="downloadshop--pc"
            />
          </a>

        <!--                Google Play Refer Link-->
        <!-- <a href="https://play.google.com/store/apps/details?id=ai.totok.chat&referrer=utm_source%3Dwebsite%26utm_medium%3Dhome"> -->
      </div>
    </div>
    <div class="copyright">
      <span>{{ t("All rights reserved","الحقوق محفوظة") }}, 2026 © TOTOK TECHNOLOGY LTD</span>
      <div>
        <img
          class="share_icon"
          src="../assets/img/twitter.png"
          alt="ToTok on twitter"
          @click="viewTwitter"
        />
        <img
          class="share_icon"
          src="../assets/img/facbook.png"
          alt="totok on facebook"
          @click="viewFacebook"
        />
        <img
          class="share_icon"
          src="../assets/img/instagram.png"
          alt="totok on instagram"
          @click="viewInstagram"
        />
        <img
          class="share_icon"
          src="../assets/img/youtube.png"
          alt="totok on youtube"
          @click="viewYouTube"
        />
      </div>
    </div>
  </footer>
</template>

<script>
import { Message } from "element-ui";
export default {
  name: "Footer",
  data() {
    return {
      appstoreTip: "",
    };
  },
  computed: {
    footNavList() {
      let defaultList =  [
        {
          label: "TOTOK",
          list: [
            {
              label: this.t("Features","المزايا "),
              href: this.t("/features","/features?lang=ar"),
            },
            {
              label: this.t("News","أخبار"),
              href: "/news-Aug04-2021",
            },
            {
              label: this.t("Security","الأمان"),
              href: this.t("/security","/security?lang=ar"),
            },
            {
              label: this.t("Terms of Use","شروط الاستخدام"),
              href: "/terms",
            },
            {
              label: this.t("Privacy Policy","سياسة الخصوصية "),
              href: "/privacy",
            },
          ],
        },
        {
          label: this.t("COMPANY","الشركة"),
          list: [
            {
              label: this.t("About","حول "),
              href: this.t("/aboutus","/aboutus?lang=ar"),
            },
            {
              label: this.t("Careers","وظائف"),
              href: this.t("/careers","/careers?lang=ar"),
            },
          ],
        },
        {
          label: this.t("HELP","مساعدة"),
          list: [
            {
              label: this.t("FAQ","الأسئلة الشائعة "),
              href: "/faq",
            },
            {
              label: this.t("Contact Us","اتصل بنا"),
              // href: "/contactus",
              href: this.t("/contactus","/contactus?lang=ar"),
            },
          ],
        },
      ];
      if(!this.isIOS()) {
        defaultList.splice(2,0,
        {
          label: this.t("DOWNLOAD","تحميل"),
          list: [ 
            // {
            //   label: "Mac - beta",
            //   href: "https://static.totok.ai/mac/ToTok_for_Mac_v1_0_2_1.dmg",
            // },
            {
              label: "Android",
              href: this.t("/download-android","/download-android?lang=ar"),
            },
          ],
        })
      }
      return defaultList;
    },
  },
  methods: {
    isIOS() {
      return navigator.userAgent.toLowerCase().indexOf("iphone") >= 0;
    },
    t(d,ar){
      if(this.$route.query.lang == "ar"){
        if(ar != undefined) return ar;
        else return d;
      } else {
        return d;
      }
    },
    sendGa(e, url) {
      //window.ga(
       // "send",
      //  "event",
       // "button",
      //  "click",
       // "Huawei donwload link click"
      //);

      if (/apps.apple/.test(url)) {
        //window.gtag("event", "download", {
         // event_category: "appstore",
         // event_label: "download",
        //});
        if (this.appstoreTip) {
          this.appstoreTip.close();
        }
        this.appstoreTip = Message({
          dangerouslyUseHTMLString: true,
          duration: 5000,
          message:
            "ToTok for iPhone is unavailable on the App Store. We're seeking a dialogue with Apple to address this issue. Join us in our request to Apple to reinstate ToTok.<br/><br/>ToTok for Android is available on our official website.",
        });
        return;
      }
     // window.gtag("event", "download", {
        //event_category: "huawei",
       // event_label: "download",
      //});
      window.location.href = url;
    },
    viewTwitter() {
      window.location.href = "https://twitter.com/totokmessenger";
    },
    viewFacebook() {
      window.location.href = "https://facebook.com/ToTokMessenger";
    },
    viewInstagram() {
      window.location.href = "https://www.instagram.com/totokmessenger";
    },
    viewYouTube() {
      window.location.href =
        "https://www.youtube.com/channel/UCNI-ZI8onKA_qUAbBTF-CFg";
    },
    appStoreTipHandle() {
     // window.gtag("event", "download", {
       // event_category: "appstore",
        //event_label: "download",
      //});
      if (this.appstoreTip) {
        this.appstoreTip.close();
      }
      this.appstoreTip = Message({
        dangerouslyUseHTMLString: true,
        duration: 5000,
        message:
          "ToTok for iPhone is unavailable on App Store.<br/> We're seeking a dialogue with Apple to address this issue. Join us to request Apple to reinstate ToTok. <br/><br/> ToTok for Android is available on our official website.",
      });
      return;
    },
  },
};
</script>

<style scoped lang="stylus">
@media only screen and (min-width: 700px) {
  .foot_box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 318px;
    width: 100%;

    // margin-top:0px;
    // padding: 0px 10%;
    background-color: #343d50;


    .nav_foot_container {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      padding: 50px 0px;
      max-width: 800px;
      width: 100%;

      .nav_foot_body {
        display: flex;
        width: 100%;
        max-width: 531px;
        flex-wrap: wrap;
        justify-content: space-between;
        font-size: 14px;
        letter-spacing: 1px;

        ul {
          color: #fff6;

          li {

            margin-top:10px;

            a {
              font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
              font-size: 14px;
              line-height 14px;
              color: #f8f8f8;
              color: #f8f8f8;
            }
          }
        }
      }

      .nav_foot_download_container {
        display: flex;
        flex-direction: column;
        a {
          padding-bottom: 8px;
        }
        .downloadshop--pc{
          width: 140px;
        }
      }
    }

    .copyright {
      display: flex;
      justify-content: space-between;
      height: 60px;
      max-width: 800px;
      width: 100%;
      color: #ffffff80;
      .share_icon {
        cursor pointer;
        width: 24px;
        height: 24px;
        margin-left: 18px;

        &:nth-child(1) {
          margin-left: 0px;
        }
      }
    }
  }
}

@media only screen and (max-width: 700px) {
  .foot_box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0px 31px;
    // margin-top:20px;
    background-color: #343d50;
    padding-bottom: 50px;

    .nav_foot_container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;

      .nav_foot_body {
        display: flex;
        height: 384px;
            max-width: 531px;
        flex-wrap: wrap;
        padding-top: 31px;
        justify-content: space-between;

        ul {
          color: #fff6;
          font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
          width: 32vw;
          font-size: 16px;
          font-weight: 500;
          letter-spacing: 0.5px;


          li {

            margin-top: 13px;

            a {
              color: #f8f8f8;
              font-size: 16px;
            }
          }
        }
      }

      .nav_foot_download_container {
        display: none;

        a {
          padding-bottom: 8px;
        }
      }
    }

    .copyright {
      display: flex;
      justify-content: space-around;
      align-items: flex-start;
      flex-flow: column-reverse;
      height: 80px;
      width: 100%;
      margin-bottom: 31px;
      color: #ffffff80;

      .share_icon {
         cursor pointer;
        width: 24px;
        height: 24px;
        margin-left: 18px;

        &:nth-child(1) {
          margin-left: 0px;
        }
      }
    }

    .downloadshop--pc {
      margin-top: 3%;
      width: 122px;
      margin-right: 1%;
    }
  }
}
</style>
